var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isSignedIn && _vm.library && _vm.isProfileLoaded && _vm.clipboardFetched)?_c('ScreenLibrary',{attrs:{"items":_vm.library,"profile":_vm.profile,"clipboardAllowed":_vm.clipboardAllowed}}):(_vm.userFetched && !_vm.isSignedIn && !_vm.isSignInFinishLink)?_c('ScreenAuth'):_c('ScreenLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }